/**
 * Доска ОО — параметры квеста игры (архив 1С, В9, решение владельца 16.10). Без React и запросов.
 * /api/quests отдаёт только активные квесты, а у игр 1С квест бывает закрытым (a1c_*, active=0) — тогда его нет в карте квестов
 * доски, и игра шла с умолчаниями (60 минут, 1 оператор). /api/bookings отдаёт параметры квеста брони (quest_duration,
 * quest_operators, quest_reset_time; apps/api/src/routes/bookings/queries.ts) — и у закрытого. Выбор: квест из /api/quests →
 * поля брони → умолчание. Тест: boardQuest.test.ts; связка с настоящими ответами — apps/api/src/routes/oo-board-1c.test.ts.
 */

/** Квест из /api/quests (нужные доске поля). */
export interface QuestParamsSrc { operators?: number; duration?: number; reset_time?: number }
/** Бронь из /api/bookings: параметры её квеста. */
export interface BookingQuestSrc { quest_operators?: number; quest_duration?: number; quest_reset_time?: number }
export interface BoardQuestParams { operatorsNeeded: number; duration: number; resetTime: number }

/** Квест из /api/quests → поля брони → умолчание (1 оператор, 60 минут, сброс 15 — как до 16.10: квеста нет нигде, старый сервер). */
export function boardQuestParams(q: QuestParamsSrc | undefined, b: BookingQuestSrc): BoardQuestParams {
  return {
    operatorsNeeded: Number(q?.operators ?? b.quest_operators ?? 1),
    duration: Number(q?.duration ?? b.quest_duration ?? 60),
    resetTime: Number(q?.reset_time ?? b.quest_reset_time ?? 15),
  };
}
